/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperationMetadataRetry
 */
export interface OperationMetadataRetry {
    /**
     * 
     * @type {number}
     * @memberof OperationMetadataRetry
     */
    attempts?: number;
    /**
     * 
     * @type {Date}
     * @memberof OperationMetadataRetry
     */
    lastAttempt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OperationMetadataRetry
     */
    lastNotified?: Date;
}

/**
 * Check if a given object implements the OperationMetadataRetry interface.
 */
export function instanceOfOperationMetadataRetry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OperationMetadataRetryFromJSON(json: any): OperationMetadataRetry {
    return OperationMetadataRetryFromJSONTyped(json, false);
}

export function OperationMetadataRetryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationMetadataRetry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attempts': !exists(json, 'attempts') ? undefined : json['attempts'],
        'lastAttempt': !exists(json, 'lastAttempt') ? undefined : (new Date(json['lastAttempt'])),
        'lastNotified': !exists(json, 'lastNotified') ? undefined : (new Date(json['lastNotified'])),
    };
}

export function OperationMetadataRetryToJSON(value?: OperationMetadataRetry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attempts': value.attempts,
        'lastAttempt': value.lastAttempt === undefined ? undefined : (value.lastAttempt.toISOString()),
        'lastNotified': value.lastNotified === undefined ? undefined : (value.lastNotified.toISOString()),
    };
}

